import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import './LegalPages.css';

export default function AGB() {
  const navigate = useNavigate();
  const [language, setLanguage] = useState('de');

  useEffect(() => {
    // Get language from localStorage (user preference) or browser
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        setLanguage(user.language || 'de');
      } catch (e) {
        setLanguage(navigator.language.startsWith('de') ? 'de' : 'en');
      }
    } else {
      setLanguage(navigator.language.startsWith('de') ? 'de' : 'en');
    }
  }, []);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'de' ? 'en' : 'de');
  };

  return (
    <div className="legal-page">
      <div className="legal-header">
        <Button 
          variant="outline" 
          onClick={() => navigate('/')}
        >
          ← {language === 'de' ? 'Zurück' : 'Back'}
        </Button>
        <Button 
          variant="outline" 
          onClick={toggleLanguage}
          className="language-toggle"
        >
          {language === 'de' ? '🇬🇧 English' : '🇩🇪 Deutsch'}
        </Button>
      </div>

      <div className="legal-content">
        {language === 'de' ? (
          <>
            <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>
            <p className="last-updated">Stand: {new Date().toLocaleDateString('de-DE')}</p>

        <section>
          <h2>§ 1 Geltungsbereich</h2>
          <p>
            (1) Diese Allgemeinen Geschäftsbedingungen (nachfolgend "AGB") gelten für alle 
            Verträge über die Nutzung der Web-Applikation "StoryTales" zur Erstellung 
            personalisierter Kindergeschichten.
          </p>
          <p>
            (2) Kunde im Sinne dieser AGB ist jede natürliche Person, die ein Nutzerkonto 
            anlegt und die Dienste von StoryTales in Anspruch nimmt.
          </p>
          <p>
            (3) Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, 
            wir hätten ausdrücklich schriftlich ihrer Geltung zugestimmt.
          </p>
        </section>

        <section>
          <h2>§ 2 Leistungsumfang</h2>
          <p>
            (1) StoryTales bietet eine Plattform zur Erstellung personalisierter Kindergeschichten 
            mit KI-generierten Illustrationen in zwei Varianten:
          </p>
          <ul>
            <li><strong>Kostenlose Version:</strong> 1 Geschichte pro Woche, PDF-Export, 
            Basisillustrationen (Nano Banana)</li>
            <li><strong>Pro-Version:</strong> 5 Geschichten pro Woche, PDF-Export, Drucken, 
            Kindle-Versand, Premium-Illustrationen (DALL-E 3 oder Nano Banana, wählbar), Anpassung von Haar- und Augenfarbe</li>
          </ul>
          <p>
            (2) Die Geschichten werden mittels künstlicher Intelligenz (Gemini 2.5 Pro für Text, 
            DALL-E 3 oder Nano Banana für Bilder) generiert und sind für Kinder im Alter von 2-10 Jahren konzipiert.
          </p>
          <p>
            (3) Wir behalten uns das Recht vor, die angebotenen Leistungen zu ändern oder zu 
            erweitern, sofern dies für den Nutzer zumutbar ist.
          </p>
        </section>

        <section>
          <h2>§ 3 Vertragsschluss und Registrierung</h2>
          <p>
            (1) Durch die Registrierung gibt der Nutzer ein verbindliches Angebot zum Abschluss 
            eines Nutzungsvertrags ab.
          </p>
          <p>
            (2) Der Vertrag kommt durch die Bestätigung der Registrierung per E-Mail zustande.
          </p>
          <p>
            (3) Der Nutzer verpflichtet sich, bei der Registrierung wahrheitsgemäße Angaben zu machen 
            und diese aktuell zu halten.
          </p>
          <p>
            (4) Ein Anspruch auf Registrierung besteht nicht. Wir können Registrierungen ohne 
            Angabe von Gründen ablehnen.
          </p>
        </section>

        <section>
          <h2>§ 4 Pro-Abonnement und Zahlungsbedingungen</h2>
          <p>
            (1) Die Pro-Version kann als monatliches Abonnement (9,99 EUR/Monat) oder als 
            Jahresabonnement (99,00 EUR/Jahr) gebucht werden.
          </p>
          <p>
            (2) Die Zahlung erfolgt über die Zahlungsanbieter Stripe oder PayPal. Es gelten 
            deren Allgemeine Geschäftsbedingungen.
          </p>
          <p>
            (3) Das Abonnement verlängert sich automatisch um den gewählten Zeitraum, sofern 
            es nicht vor Ablauf der jeweiligen Laufzeit gekündigt wird.
          </p>
          <p>
            (4) Alle Preise verstehen sich inklusive der gesetzlichen Mehrwertsteuer.
          </p>
          <p>
            (5) Bei Zahlungsverzug sind wir berechtigt, den Zugang zum Pro-Abonnement zu sperren.
          </p>
        </section>

        <section>
          <h2>§ 5 Widerrufsrecht für Verbraucher</h2>
          <p>
            <strong>Widerrufsbelehrung:</strong>
          </p>
          <p>
            Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag 
            zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.
          </p>
          <p>
            Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (StoryTales, info@storytales.xyz) mittels 
            einer eindeutigen Erklärung (z.B. ein mit der Post versandter Brief oder E-Mail) über 
            Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.
          </p>
          <p>
            <strong>Folgen des Widerrufs:</strong>
          </p>
          <p>
            Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen 
            erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag 
            zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns 
            eingegangen ist.
          </p>
          <p>
            <strong>Ausschluss des Widerrufsrechts:</strong>
          </p>
          <p>
            Das Widerrufsrecht erlischt bei Dienstleistungsverträgen, wenn wir die Dienstleistung 
            vollständig erbracht haben und mit der Ausführung der Dienstleistung erst begonnen haben, 
            nachdem Sie dazu Ihre ausdrückliche Zustimmung gegeben haben und gleichzeitig Ihre 
            Kenntnis davon bestätigt haben, dass Sie Ihr Widerrufsrecht bei vollständiger 
            Vertragserfüllung durch uns verlieren.
          </p>
        </section>

        <section>
          <h2>§ 6 Kündigung</h2>
          <p>
            (1) Das kostenlose Nutzerkonto kann jederzeit ohne Einhaltung einer Frist gekündigt werden.
          </p>
          <p>
            (2) Das Pro-Abonnement kann jederzeit über die Einstellungen gekündigt werden. Die 
            Kündigung wird zum Ende des bezahlten Zeitraums wirksam.
          </p>
          <p>
            (3) Wir sind berechtigt, das Nutzerkonto fristlos zu kündigen, wenn der Nutzer gegen 
            diese AGB verstößt, insbesondere bei:
          </p>
          <ul>
            <li>Missbräuchlicher Nutzung der Plattform</li>
            <li>Erstellung von Geschichten mit gewaltverherrlichenden, diskriminierenden oder 
            jugendgefährdenden Inhalten</li>
            <li>Weitergabe von Zugangsdaten an Dritte</li>
            <li>Zahlungsverzug</li>
          </ul>
        </section>

        <section>
          <h2>§ 7 Nutzungsrechte und Urheberrecht</h2>
          <p>
            (1) Alle durch StoryTales erstellten Geschichten und Illustrationen stehen dem Nutzer 
            für den privaten, nicht-kommerziellen Gebrauch zur Verfügung.
          </p>
          <p>
            (2) Der Nutzer erhält ein einfaches, nicht übertragbares Nutzungsrecht an den von ihm 
            erstellten Geschichten.
          </p>
          <p>
            (3) Die kommerzielle Verwertung der Geschichten (z.B. Verkauf, öffentliche Aufführung) 
            bedarf unserer vorherigen schriftlichen Zustimmung.
          </p>
          <p>
            (4) Die Illustrationen werden mittels KI generiert. Die Nutzung erfolgt im Rahmen der 
            OpenAI-Nutzungsbedingungen.
          </p>
        </section>

        <section>
          <h2>§ 8 Pflichten des Nutzers</h2>
          <p>
            (1) Der Nutzer verpflichtet sich:
          </p>
          <ul>
            <li>Seine Zugangsdaten geheim zu halten und nicht an Dritte weiterzugeben</li>
            <li>Keine Geschichten mit gewaltverherrlichenden, diskriminierenden, 
            jugendgefährdenden oder sonst rechtswidrigen Inhalten zu erstellen</li>
            <li>Die wöchentlichen Nutzungslimits zu respektieren</li>
            <li>Keine technischen Schutzmaßnahmen zu umgehen</li>
          </ul>
          <p>
            (2) Bei Verdacht auf Missbrauch der Zugangsdaten ist der Nutzer verpflichtet, uns 
            unverzüglich zu informieren.
          </p>
        </section>

        <section>
          <h2>§ 9 Datenschutz</h2>
          <p>
            Die Verarbeitung personenbezogener Daten erfolgt gemäß unserer Datenschutzerklärung, 
            die unter dem Menüpunkt "Datenschutz" abrufbar ist und Bestandteil dieser AGB ist.
          </p>
        </section>

        <section>
          <h2>§ 10 KI-generierte Inhalte und Haftungsausschluss</h2>
          <p>
            (1) <strong>Art der KI-generierten Inhalte:</strong> StoryTales verwendet künstliche 
            Intelligenz zur vollständigen Generierung von Geschichtentexten (Google Gemini 2.5 Pro) 
            und Illustrationen (OpenAI DALL-E 3 oder Google Nano Banana). Beide Inhaltstypen werden automatisiert ohne 
            menschliche Überprüfung erstellt.
          </p>
          <p>
            (2) <strong>Keine Gewährleistung für KI-Inhalte:</strong> Wir übernehmen keinerlei 
            Gewähr oder Garantie für:
          </p>
          <ul>
            <li>Sachliche Richtigkeit und Vollständigkeit der Geschichtentexte</li>
            <li>Pädagogische Eignung oder Altersangemessenheit der Inhalte</li>
            <li>Kulturelle Sensibilität oder angemessene Darstellung verschiedener Gruppen</li>
            <li>Vorhersehbarkeit oder Konsistenz der generierten Inhalte</li>
            <li>Urheberrechtliche Schutzfähigkeit der KI-generierten Werke</li>
            <li>Fehlerfreiheit oder Vollständigkeit der Illustrationen</li>
          </ul>
          <p>
            (3) <strong>Bekannte KI-Limitierungen:</strong> Der Nutzer wird ausdrücklich darauf 
            hingewiesen, dass KI-Systeme:
          </p>
          <ul>
            <li>Fakten erfinden oder falsch darstellen können ("KI-Halluzinationen")</li>
            <li>Unvorhersehbare, unbeabsichtigte oder unangemessene Inhalte erzeugen können</li>
            <li>Stereotype, Vorurteile oder kulturell problematische Darstellungen reproduzieren können</li>
            <li>Inkonsistenzen in Charakterdarstellungen oder Handlungssträngen aufweisen können</li>
            <li>Trotz Moderationsfiltern gelegentlich grenzwertige Inhalte produzieren können</li>
          </ul>
          <p>
            (4) <strong>Elterliche Aufsichtspflicht:</strong> Der Nutzer erkennt an und stimmt zu, 
            dass die generierten Geschichten NICHT als pädagogisch geprüftes Material gelten. Eltern 
            und Erziehungsberechtigte MÜSSEN jede Geschichte VOR dem Vorlesen an Kinder auf 
            Angemessenheit überprüfen. Die Nutzung ersetzt nicht die elterliche Verantwortung.
          </p>
          <p>
            (5) <strong>Inhaltsmoderation:</strong> Wir setzen automatisierte Filter und 
            Moderationssysteme ein, um offensichtlich unangemessene Inhalte (Gewalt, sexuelle 
            Inhalte, Diskriminierung) zu verhindern. Eine 100%ige Filterung kann jedoch technisch 
            nicht garantiert werden. Nutzer verpflichten sich, problematische Inhalte unverzüglich 
            zu melden.
          </p>
          <p>
            (6) <strong>Meldung problematischer Inhalte:</strong> Bei Feststellung unangemessener 
            Inhalte ist der Nutzer verpflichtet, diese über info@storytales.xyz zu melden. Wir 
            werden gemeldete Inhalte prüfen und gegebenenfalls Maßnahmen ergreifen.
          </p>
        </section>

        <section>
          <h2>§ 11 Haftungsbeschränkungen</h2>
          <p>
            (1) Für Schäden haften wir - gleich aus welchem Rechtsgrund - im Rahmen der 
            Verschuldenshaftung bei Vorsatz und grober Fahrlässigkeit unbeschränkt.
          </p>
          <p>
            (2) Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten ist die Haftung 
            auf den vertragstypischen, vorhersehbaren Schaden begrenzt.
          </p>
          <p>
            (3) <strong>Ausschluss der Haftung für KI-Inhalte:</strong> Eine Haftung für 
            psychologische, pädagogische, emotionale oder sonstige Auswirkungen der KI-generierten 
            Geschichten auf Kinder ist ausgeschlossen, soweit gesetzlich zulässig.
          </p>
          <p>
            (4) <strong>Keine Haftung für Urheberrechtsverletzungen:</strong> Wir übernehmen keine 
            Haftung für mögliche Urheberrechtsverletzungen durch KI-generierte Inhalte. Die 
            rechtliche Situation bezüglich KI-Urheberrecht ist in vielen Jurisdiktionen ungeklärt.
          </p>
          <p>
            (5) Die Verfügbarkeit der Plattform beträgt im Jahresdurchschnitt mindestens 95%. 
            Ausgenommen hiervon sind Wartungszeiten, KI-API-Ausfälle und Störungen, die außerhalb 
            unseres Einflussbereichs liegen.
          </p>
          <p>
            (6) <strong>Haftungsausschluss für Drittanbieter-KI:</strong> Wir nutzen 
            KI-Dienste von Drittanbietern (Google, OpenAI). Deren Verfügbarkeit, Qualität und 
            Funktionalität liegen außerhalb unserer Kontrolle. Wir haften nicht für Ausfälle, 
            Qualitätsmängel oder Änderungen dieser Drittanbieter-Dienste.
          </p>
        </section>

        <section>
          <h2>§ 12 Änderung der AGB</h2>
          <p>
            (1) Wir behalten uns das Recht vor, diese AGB mit Wirkung für die Zukunft zu ändern.
          </p>
          <p>
            (2) Über Änderungen werden die Nutzer spätestens vier Wochen vor dem geplanten 
            Inkrafttreten per E-Mail informiert.
          </p>
          <p>
            (3) Widerspricht der Nutzer den geänderten AGB nicht innerhalb von vier Wochen nach 
            Zugang der Änderungsmitteilung, gelten die geänderten AGB als angenommen. Auf diese 
            Folge werden wir in der Änderungsmitteilung hinweisen.
          </p>
        </section>

        <section>
          <h2>§ 13 Schlussbestimmungen</h2>
          <p>
            (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des 
            UN-Kaufrechts.
          </p>
          <p>
            (2) Gerichtsstand für alle Streitigkeiten ist, soweit gesetzlich zulässig, unser 
            Geschäftssitz.
          </p>
          <p>
            (3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die 
            Wirksamkeit der übrigen Bestimmungen hiervon unberührt.
          </p>
        </section>

        <section className="contact-section">
          <h2>Kontakt</h2>
          <p>
            Bei Fragen zu diesen AGB können Sie uns unter folgender E-Mail-Adresse erreichen:<br />
            <strong>info@storytales.xyz</strong>
          </p>
        </section>
          </>
        ) : (
          <>
            <h1>Terms and Conditions</h1>
            <p className="last-updated">Last updated: {new Date().toLocaleDateString('en-US')}</p>

            <section>
              <h2>§ 1 Scope</h2>
              <p>
                (1) These General Terms and Conditions ("Terms") apply to all contracts for the use 
                of the "StoryTales" web application for creating personalized children's stories.
              </p>
              <p>
                (2) A customer within the meaning of these Terms is any natural person who creates 
                a user account and uses the services of StoryTales.
              </p>
              <p>
                (3) Deviating conditions of the customer are not recognized unless we have expressly 
                agreed to their validity in writing.
              </p>
            </section>

            <section>
              <h2>§ 2 Scope of Services</h2>
              <p>
                (1) StoryTales offers a platform for creating personalized children's stories with 
                AI-generated illustrations in two versions:
              </p>
              <ul>
                <li><strong>Free Version:</strong> 2 total stories, PDF export, basic illustrations (Nano Banana)</li>
                <li><strong>Pro Version:</strong> 4 stories per month, PDF export, print, Kindle delivery, 
                premium illustrations (DALL-E 3 or Nano Banana, selectable), hair and eye color customization</li>
              </ul>
              <p>
                (2) Stories are generated using artificial intelligence (Gemini 2.5 Pro for text, 
                DALL-E 3 or Nano Banana for images) and are designed for children aged 2-10 years.
              </p>
              <p>
                (3) We reserve the right to change or expand the services offered, provided this is 
                reasonable for the user.
              </p>
            </section>

            <section>
              <h2>§ 3 Contract Conclusion and Registration</h2>
              <p>
                (1) By registering, the user makes a binding offer to conclude a usage agreement.
              </p>
              <p>
                (2) The contract is concluded by confirming the registration via email.
              </p>
              <p>
                (3) The user undertakes to provide truthful information during registration and to 
                keep it up to date.
              </p>
              <p>
                (4) There is no entitlement to registration. We may reject registrations without 
                giving reasons.
              </p>
            </section>

            <section>
              <h2>§ 4 Pro Subscription and Payment Terms</h2>
              <p>
                (1) The Pro version can be booked as a monthly subscription ($9.99/month) or as an 
                annual subscription ($99.00/year).
              </p>
              <p>
                (2) Payment is made via the payment providers Stripe or PayPal. Their General Terms 
                and Conditions apply.
              </p>
              <p>
                (3) The subscription is automatically renewed for the selected period unless it is 
                canceled before the end of the respective term.
              </p>
              <p>
                (4) All prices include statutory VAT.
              </p>
              <p>
                (5) In case of default in payment, we are entitled to block access to the Pro subscription.
              </p>
            </section>

            <section>
              <h2>§ 5 Right of Withdrawal for Consumers</h2>
              <p>
                <strong>Withdrawal Information:</strong>
              </p>
              <p>
                You have the right to withdraw from this contract within fourteen days without giving 
                any reason. The withdrawal period is fourteen days from the date of conclusion of the contract.
              </p>
              <p>
                To exercise your right of withdrawal, you must inform us (StoryTales, info@storytales.xyz) 
                of your decision to withdraw from this contract by means of a clear statement (e.g. a 
                letter sent by post or email).
              </p>
              <p>
                <strong>Consequences of Withdrawal:</strong>
              </p>
              <p>
                If you withdraw from this contract, we shall reimburse you all payments we have received 
                from you immediately and at the latest within fourteen days from the day on which we 
                received notification of your withdrawal from this contract.
              </p>
              <p>
                <strong>Exclusion of the Right of Withdrawal:</strong>
              </p>
              <p>
                The right of withdrawal expires in the case of service contracts if we have fully 
                performed the service and only began performing the service after you gave your express 
                consent and at the same time confirmed your knowledge that you will lose your right of 
                withdrawal upon complete performance of the contract by us.
              </p>
            </section>

            <section>
              <h2>§ 6 Termination</h2>
              <p>
                (1) The free user account can be terminated at any time without notice.
              </p>
              <p>
                (2) The Pro subscription can be canceled at any time via the settings. The cancellation 
                becomes effective at the end of the paid period.
              </p>
              <p>
                (3) We are entitled to terminate the user account without notice if the user violates 
                these Terms, in particular in case of:
              </p>
              <ul>
                <li>Abusive use of the platform</li>
                <li>Creation of stories with glorifying violence, discriminatory or content harmful to minors</li>
                <li>Sharing of access data with third parties</li>
                <li>Default in payment</li>
              </ul>
            </section>

            <section>
              <h2>§ 7 Usage Rights and Copyright</h2>
              <p>
                (1) All stories and illustrations created by StoryTales are available to the user for 
                private, non-commercial use.
              </p>
              <p>
                (2) The user receives a simple, non-transferable right to use the stories created by them.
              </p>
              <p>
                (3) Commercial exploitation of the stories (e.g. sale, public performance) requires our 
                prior written consent.
              </p>
              <p>
                (4) The illustrations are generated using AI. Usage is subject to OpenAI's terms of use.
              </p>
            </section>

            <section>
              <h2>§ 8 User Obligations</h2>
              <p>
                (1) The user undertakes to:
              </p>
              <ul>
                <li>Keep their access data secret and not share it with third parties</li>
                <li>Not create stories with glorifying violence, discriminatory, content harmful to 
                minors or otherwise illegal content</li>
                <li>Respect the weekly usage limits</li>
                <li>Not circumvent technical protection measures</li>
              </ul>
              <p>
                (2) If there is suspicion of misuse of access data, the user is obliged to inform us immediately.
              </p>
            </section>

            <section>
              <h2>§ 9 Data Protection</h2>
              <p>
                The processing of personal data is carried out in accordance with our Privacy Policy, 
                which is available under the menu item "Privacy" and is part of these Terms.
              </p>
            </section>

            <section>
              <h2>§ 10 AI-Generated Content and Disclaimer</h2>
              <p>
                (1) <strong>Nature of AI-Generated Content:</strong> StoryTales uses artificial 
                intelligence to fully generate story texts (Google Gemini 2.5 Pro) and illustrations 
                (OpenAI DALL-E 3 or Google Nano Banana). Both content types are created automatically without human review.
              </p>
              <p>
                (2) <strong>No Warranty for AI Content:</strong> We provide no warranty or guarantee for:
              </p>
              <ul>
                <li>Factual accuracy and completeness of story texts</li>
                <li>Pedagogical suitability or age-appropriateness of content</li>
                <li>Cultural sensitivity or appropriate representation of different groups</li>
                <li>Predictability or consistency of generated content</li>
                <li>Copyright protection eligibility of AI-generated works</li>
                <li>Error-free or complete illustrations</li>
              </ul>
              <p>
                (3) <strong>Known AI Limitations:</strong> The user is expressly informed that AI systems may:
              </p>
              <ul>
                <li>Invent or misrepresent facts ("AI hallucinations")</li>
                <li>Generate unpredictable, unintended, or inappropriate content</li>
                <li>Reproduce stereotypes, biases, or culturally problematic representations</li>
                <li>Display inconsistencies in character portrayals or storylines</li>
                <li>Occasionally produce borderline content despite moderation filters</li>
              </ul>
              <p>
                (4) <strong>Parental Supervision Required:</strong> The user acknowledges and agrees 
                that the generated stories are NOT considered pedagogically reviewed material. Parents 
                and guardians MUST review each story for appropriateness BEFORE reading it to children. 
                Using the platform does not replace parental responsibility.
              </p>
              <p>
                (5) <strong>Content Moderation:</strong> We employ automated filters and moderation 
                systems to prevent obviously inappropriate content (violence, sexual content, 
                discrimination). However, 100% filtering cannot be technically guaranteed. Users 
                agree to immediately report problematic content.
              </p>
              <p>
                (6) <strong>Reporting Problematic Content:</strong> Upon discovering inappropriate 
                content, the user is obligated to report it via info@storytales.xyz. We will review 
                reported content and take appropriate action if necessary.
              </p>
            </section>

            <section>
              <h2>§ 11 Limitation of Liability</h2>
              <p>
                (1) We are liable for damages - regardless of the legal grounds - in the context of 
                fault liability for intent and gross negligence without limitation.
              </p>
              <p>
                (2) In the case of slightly negligent breach of essential contractual obligations, 
                liability is limited to the contractual, foreseeable damage.
              </p>
              <p>
                (3) <strong>Exclusion of Liability for AI Content:</strong> Liability for 
                psychological, pedagogical, emotional, or other effects of AI-generated stories on 
                children is excluded to the extent legally permissible.
              </p>
              <p>
                (4) <strong>No Liability for Copyright Infringement:</strong> We assume no liability 
                for possible copyright infringements by AI-generated content. The legal situation 
                regarding AI copyright is unclear in many jurisdictions.
              </p>
              <p>
                (5) The availability of the platform is at least 95% on annual average. Excluded from 
                this are maintenance times, AI API outages, and disruptions outside our sphere of influence.
              </p>
              <p>
                (6) <strong>Third-Party AI Disclaimer:</strong> We use AI services from third-party 
                providers (Google, OpenAI). Their availability, quality, and functionality are beyond 
                our control. We are not liable for outages, quality defects, or changes to these 
                third-party services.
              </p>
            </section>

            <section>
              <h2>§ 12 Amendment of the Terms</h2>
              <p>
                (1) We reserve the right to amend these Terms with effect for the future.
              </p>
              <p>
                (2) Users will be informed of changes at least four weeks before the planned entry 
                into force by email.
              </p>
              <p>
                (3) If the user does not object to the amended Terms within four weeks of receipt of 
                the notification of change, the amended Terms shall be deemed accepted. We will point 
                out this consequence in the notification of change.
              </p>
            </section>

            <section>
              <h2>§ 13 Final Provisions</h2>
              <p>
                (1) The law of the Federal Republic of Germany applies, excluding the UN Convention 
                on Contracts for the International Sale of Goods.
              </p>
              <p>
                (2) The place of jurisdiction for all disputes is, insofar as legally permissible, 
                our registered office.
              </p>
              <p>
                (3) Should individual provisions of these Terms be or become invalid, the validity 
                of the remaining provisions shall remain unaffected.
              </p>
            </section>

            <section className="contact-section">
              <h2>Contact</h2>
              <p>
                If you have any questions about these Terms, you can reach us at the following email address:<br />
                <strong>info@storytales.xyz</strong>
              </p>
            </section>
          </>
        )}
      </div>
    </div>
  );
}
